import React, { FC, useCallback, useMemo, useRef, UIEvent } from 'react';

import { Stack, useDesktop } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';

import { Header } from './Header';
import { Body, BodyProps } from './Body';


export type EmissionsTableProps = Omit<BodyProps, 'columnsWidth' | 'onScroll'>;

export const EmissionssTable: FC<EmissionsTableProps> = ({ data, columns, ...props }) => {
    const { t } = useTranslation('emissionsTable');
    const isDesktop = useDesktop();
    const columnsWidth = useMemo(() =>
        columns.map(({ width, mobileWidth }) => `${isDesktop ? width : mobileWidth}px`),
    [isDesktop, columns]);

    const tableProps = { columns, t, columnsWidth, isDesktop };

    const headerRef = useRef<HTMLDivElement>(null);
    const bodyRef = useRef<HTMLDivElement>(null);
    const onHeaderScroll = useCallback((e: UIEvent<HTMLDivElement>) => {
        bodyRef.current.scrollLeft = e.currentTarget.scrollLeft;
    },
    [bodyRef]);
    const onBodyScroll = useCallback((e: UIEvent<HTMLDivElement>) => {
        headerRef.current.scrollLeft = e.currentTarget.scrollLeft;
    },
    [headerRef]);
    return (
        <Stack width='100%' minHeight={isDesktop ? '585px' : '439px'}>
            <Header {...tableProps} ref={headerRef} onScroll={onHeaderScroll} />
            <Body {...tableProps} data={data} ref={bodyRef} onScroll={onBodyScroll} {...props} />
        </Stack>
    );
};
